module.exports = __webpack_public_path__ + "img/Summary_Monitor.0892ad14.jpg";